module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/ap_bubble_purple-0336e0ba93a216fe05e662dd2c2a9dbb.svg";